var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      ref: "main",
      staticClass: "QR",
      attrs: { href: "#" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.generateQR.apply(null, arguments)
        }
      }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("canvas", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.qrOpened,
            expression: "qrOpened"
          }
        ],
        attrs: { id: "qr-code" }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", {
        staticClass: "fa fa-qrcode",
        staticStyle: { "font-size": "13px" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-998afb86", { render: render, staticRenderFns: staticRenderFns })
  }
}